import { useAtom } from '@reatom/npm-react'
import { throttle } from 'radash'
import React, { useEffect, useMemo, useState } from 'react'

import { PairPopover } from '@root/features/pair'

import { TopbarPairItem } from '../common/topbar-pair-item'

import type { PairModel } from '@root/entities/pair'
import type { ClassNameProps } from '@root/shared/react'

type Props = {
  pair: PairModel
} & ClassNameProps

/** At most one display refresh per this interval (first update in a window is immediate). */
const DISPLAY_THROTTLE_MS = 5000

export const TopbarTrendingItem = ({ pair, className }: Props) => {
  const [mcap] = useAtom(pair.marketCapUsd)
  const [priceChange] = useAtom(pair.stats['1D'].priceChange)
  const [display, setDisplay] = useState({
    mcap,
    percents: priceChange.toNumber(),
  })

  const setDisplayThrottled = useMemo(
    () => throttle({ interval: DISPLAY_THROTTLE_MS }, setDisplay),
    [],
  )

  useEffect(() => {
    setDisplayThrottled({ mcap, percents: priceChange.toNumber() })
  }, [mcap, priceChange, setDisplayThrottled])

  return (
    <PairPopover pair={pair} sideOffset={2}>
      <TopbarPairItem
        className={className}
        pair={pair}
        amountUsd={display.mcap}
        amountFormat="mcap"
        percents={display.percents}
      />
    </PairPopover>
  )
}
